export default "__VITE_ASSET__G43RN9cr__"